import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=d353bc30&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d353bc30')) {
      api.createRecord('d353bc30', component.options)
    } else {
      api.reload('d353bc30', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=d353bc30&", function () {
      api.rerender('d353bc30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Bs51WByZ7SeV/JS/comp/ImgFallback.vue"
export default component.exports